(function () {
  if (window.swapwearBundleReview) return;

  const config = document.currentScript?.dataset || {};
  const override = new URLSearchParams(window.location.search).get('bundle_review');
  const enabled = config.enabled === 'true' && override !== 'A';
  let pending = null;

  async function settle(root, { timeoutMs = 15000 } = {}) {
    if (typeof root.settleCartForCheckout === 'function') return root.settleCartForCheckout({ timeoutMs });
    let confirmed = false;
    let failed = false;
    let timer;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error('cart-review-timeout')), timeoutMs);
    });
    const wait = promise => Promise.race([promise, timeout]);
    const onUpdate = () => { confirmed = true; };
    const onFailure = event => { if (event.detail?.mutation) failed = true; };
    const busy = () => root._cartMutationQueue || root._cartUpdatePromise ||
      root._cartRequestInFlight || root._cartRefreshQueued || root._addingMystery2 ||
      root._removingMystery2;
    const drain = async () => {
      do {
        await wait(Promise.all([
          root._cartMutationQueue,
          root._cartUpdatePromise
        ].filter(Boolean)));
        await wait(new Promise(resolve => setTimeout(resolve, 50)));
        if (failed || root.show_alert) throw new Error('cart-review-update-failed');
      } while (busy());
    };

    window.addEventListener('cart:updated', onUpdate);
    window.addEventListener('swapwear:request-failed', onFailure);
    try {
      await drain();
      confirmed = false;
      await wait(root.updateCart(false));
      await drain();
      if (!confirmed || failed || root.canAddMystery2Reward()) {
        throw new Error('cart-review-not-current');
      }
      return root.cart;
    } finally {
      clearTimeout(timer);
      window.removeEventListener('cart:updated', onUpdate);
      window.removeEventListener('swapwear:request-failed', onFailure);
    }
  }

  window.swapwearBundleReview = {
    enabled,
    version: 'bundle-review-v1',
    settle,
    prepare() {
      if (pending) return pending;
      const root = (document.documentElement?._x_dataStack || []).find(scope =>
        typeof scope?.updateCart === 'function'
      );
      if (!root) return Promise.reject(new Error('cart-review-unavailable'));
      pending = settle(root).finally(() => { pending = null; });
      return pending;
    }
  };
}());
